import makeStyles from "@mui/styles/makeStyles";
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    getAdmissionType,
    getMarkedOperation,
    reload,
    setContentView,
    setMarkedOperation,
} from '../../../../store/reducers/booked_admissions';
import {Button, TextField} from '@mui/material';
import API from "../../../../app/api";
import {proceduresLen} from '../../../bookAdmission/workList';
import clsx from "clsx";
import AdmissionDecisions from "./admissionDecisions";
import BookAdmissionForm from '../../../bookAdmission/createBookAdmissionForm';
import useOpenState from '../../../../hooks/useOpenState';
import MessageBox from '../../../../util/messageBox';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import {setSnackbar} from '../../../../store/reducers/globals';

import moment from "moment";
import {hasBAPermission, hasOneOfPermission, isBaAdmin, Permissions, user} from '../../../../store/reducers/user';
import {contentViewTypes} from '../content';
import ButtonGroup from '@mui/material/ButtonGroup';
import PatientAlertsComponent from '../../../bookAdmission/patientAlertsComponent';
import {HistoryIcon} from '../../../../components/icons/icons';
import _ from 'lodash';
import {admissionViewTypes} from '../../bookedAdmissions';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import AgyleDialog from '../../../../components/modal/agyleDialog';
import {Tooltip} from '@material-ui/core';

export const InformationTab = {
    FORM: "form",
    DECISIONS: "decisions",
    CONTACT_HISTORY: "contactHistory"
}

export const useStyles = makeStyles((theme) => ({
    admissionCard: {
        height: 100,
        background: "#3d3e40",
        margin: "5px 0 5px 0",
        borderRadius: 5,
        borderLeft: "5px solid red",
        padding: 5
    },
    typeContainer: {
        justifyContent: "flex-end",
        display: "flex",
        margin: 0,//"5px 0 5px 0"
    },
    statusItem: {
        width: "20%",
        textAlign: "center",
        color: theme.palette.bookAdmissions.tabColor,
        cursor: "pointer",
        padding: 5,
        fontSize: 15,
        borderBottom: "2px solid "+theme.palette.background.default,
    },
    itemSelected: {
        borderBottom: "2px solid "+theme.palette.primary.main,
        color: theme.palette.bookAdmissions.tabSelectedColor,
        fontWeight: 700,
        transition: "border 0.6s linear"
    },
    header: {
        height: "50px",
        margin: "10px 0px",
        fontSize: "16px",
        background: theme.palette.mode === "dark" ? "#313233" : "#dee1e5",
        fontWeight: "bold",
        borderRadius: "7px",
        display: "flex",
        alignItems: "center",
        paddingLeft: "10px",
        paddingRight: "10px",
        justifyContent: "space-between"
    },
    formButtons: {
        marginTop: 5,
        textAlign: "right",
        display: "flex",
        alignItems: "center"
    },
    procedureSpecialty: {
        width: "70px",
        border: "1px solid grey",
        display: "inline-flex",
        padding: "3px",
        borderRadius: "8px",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: 500,
        margin: "0px 5px"
    },
    deleteButtons: {
        textTransform: "none",
        paddingRight: 10,
        fontSize: "1rem"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#f2f2f2"
    },
}));


const AdmissionInformation = (props) => {
    const classes = useStyles();

    const markedOperation = useSelector(getMarkedOperation);
    const dispatch = useDispatch();

    const [tab, setTab] = React.useState(InformationTab.FORM);
    const signalSubmit = new AbortController();
    const userObject = useSelector(user);

    const [deleteRebook, setDeleteRebook] = React.useState(false);
    const [deleteReason, setDeleteReason] = React.useState("");

    const [isConfirmModalOpen, openConfirmModal, closeConfirmModal] = useOpenState(false, true);
    const [transfer, setTransfer] = useState(false);

    const controller = new AbortController();


    const removeAcceptTime = (markedOperation) => {

        let filter = `_id eq_id '${markedOperation.id}'`;
        API.getOperation(filter).then(operations => {

                let operationTmp = _.cloneDeep(operations[0]);
                operationTmp['patientAcceptsToComeIn'] = null

                delete operationTmp.sessiosObj;
                delete operationTmp.href;
                delete operationTmp.type;
                delete operationTmp.patient;

                if(operationTmp.overseeingConsultant) {
                    operationTmp.overseeingConsultant = {
                        id: operationTmp.overseeingConsultant.id,
                        name: operationTmp.overseeingConsultant.name,
                    }
                }

                API.admissionUpdate(operationTmp, controller.signal).then(
                    (res) => {
                        dispatch(reload());

                    }
                )
            })
            .catch(error => {
                // TODO: error handler !!!
                console.error(error);
            }).finally(()=>{
                dispatch(setMarkedOperation());
                dispatch(setContentView(contentViewTypes.SCHEDULE))
                closeConfirmModal()

        });

    }

    const removeSession = () => {
        if(markedOperation.bookedSession) {
            let data = {
                theatreSessionId: markedOperation.bookedSession,
                operationId: markedOperation.id,
                opTimeLen: proceduresLen(markedOperation),
                remove: true,
                cancelStatus: deleteRebook? "rebook": "delete",
                comment: deleteReason
            }

            API.theatreSessionsAddOperation(data).then(operations => {
                dispatch(reload());

                if(markedOperation.patientAcceptsToComeIn) {
                    removeAcceptTime(markedOperation)
                } else {
                    dispatch(setMarkedOperation());
                    dispatch(setContentView(contentViewTypes.SCHEDULE))
                    closeConfirmModal()
                }
                dispatch(setSnackbar({
                    type: "success",
                    message: "Operation removed from session",
                }));

            }).catch(function (error) {
                // TODO: error handler !!!
                closeConfirmModal()
                dispatch(reload());
                dispatch(setMarkedOperation());
                dispatch(setContentView(contentViewTypes.SCHEDULE))
                dispatch(setSnackbar({
                    type: "Error",
                    message: "Operation not removed from session",
                }));

                console.error(error);
            });
        } else {

            let tmpAdmission = {...markedOperation};
            tmpAdmission.cancelInfo = {
                lastBookedSession: null,
                notes: deleteReason,
                status: "delete",
                date: moment(),
                who: userObject?.userName,
            }

            delete tmpAdmission["href"];
            delete tmpAdmission["patient"];
            delete tmpAdmission["type"];
            delete tmpAdmission["sessiosObj"];

            API.admissionUpdate(tmpAdmission, signalSubmit.signal).then(
                (res) => {
                    dispatch(setMarkedOperation(res));
                    dispatch(reload());
                    closeConfirmModal()

                    dispatch(setSnackbar({
                            type: "success",
                            message: "Form Deleted",
                    }));
                }
            ).catch(error => {
                dispatch(setMarkedOperation());
                dispatch(reload());
                closeConfirmModal()
                dispatch(setSnackbar({
                    type: "error",
                    message: error.message,
                }));
            });
        }

    }

    const handleOpenConfirmModal = (rebook) => {
        setDeleteRebook(rebook);
        setDeleteReason("");
        openConfirmModal()
    }

    const handleTimeLineClick = () => {
        setHistoryView(!historyView)
    }
    const renderMessage = () => {
        return <div>
            <TextField
                label={"Reason"}
                name={"Reason"}
                onChange={(e) => setDeleteReason(e.target.value)}
                value={deleteReason}
                fullWidth
                multiline
            /> </div>
    }


    const moveMduToTCI = () => {
        setTransfer(true)
    }

    useEffect(()=>{
        setTransfer(false);
        setHistoryView(false);
    },[markedOperation])

    const [historyView, setHistoryView] = React.useState(false);
    const admissionType = useSelector(getAdmissionType);

    const userCanCancelOrDeleteForm = () => {
        if(markedOperation.patient === null) return false;
        if(admissionViewTypes.THEATRES === admissionType) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_T_TCI_SL, admissionType));
        if(admissionViewTypes.MDU === admissionType) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_MDU_ON_SL, admissionType));
    }

    const userCanDeleteUnscheduledForm = () => {
        if(markedOperation.patient === null) return false;
        if(admissionViewTypes.THEATRES === admissionType) return dispatch(hasBAPermission(Permissions.BA_CAN_MANAGE_TCI_UL, admissionType));
        if(admissionViewTypes.MDU === admissionType) return dispatch(hasOneOfPermission([Permissions.BA_CAN_MANAGE_MDU_UL, Permissions.BA_CAN_MANAGE_MDU_ADMISSIONS])) || dispatch(isBaAdmin(admissionType));
    }

    const renderButtons = () => {
        return  <>
            {markedOperation && !markedOperation.bookedSession && (!markedOperation.cancelInfo || markedOperation.cancelInfo.status !== "delete") &&
                <Tooltip title={markedOperation.patient === null? "MISSING PATIENT RECORD" : ""}
                         placement="top">
                    <div>
                        <Button className={classes.deleteButtons}
                                onClick={() => handleOpenConfirmModal(false)}
                                size="small"
                                color="primary"
                                disabled={!userCanDeleteUnscheduledForm()}
                                variant="text">
                            Delete
                        </Button>
                    </div>
                </Tooltip>
            }
            {markedOperation && markedOperation.bookedSession &&
            <Tooltip title={markedOperation.patient === null? "MISSING PATIENT RECORD" : ""} placement="top">
                <div>
                    <Button className={classes.deleteButtons}
                            onClick={()=>handleOpenConfirmModal(false)}
                            size="small"
                            color="primary"
                            disabled={!userCanCancelOrDeleteForm()}
                            variant="text">
                        Delete
                    </Button>
                </div>
            </Tooltip>
            }

            {markedOperation && markedOperation.bookedSession &&
            <Tooltip title={markedOperation.patient === null ? "MISSING PATIENT RECORD" : ""} placement="top">
                <div>
                    <Button className={classes.deleteButtons}
                            onClick={() => handleOpenConfirmModal(true)}
                            size="small"
                            color="primary"
                            disabled={!userCanCancelOrDeleteForm()}
                            variant="text">
                        Cancel and Rebook
                    </Button>
                </div>
            </Tooltip>
            }
            {markedOperation &&
                <AgyleButton
                    size="small"
                    style={{marginLeft: 5}}
                    onClick={() => handleTimeLineClick()}
                    color={historyView? "primary": "inherit"}
                    startIcon={<HistoryIcon/>}>
                    Timeline
                </AgyleButton>
            }
        </>
    }
    return(<div >
        {isConfirmModalOpen &&
        <AgyleDialog
            contentStyle={classes.dialogContentStyle}
            title={"Please Confirm " + (deleteRebook? "Cancel and Rebook": "Delete")}
            open={isConfirmModalOpen}
            onClose={closeConfirmModal}
            fullWidth
            disableActions
            closeButtonOnHeader
        >
            <div>
                <TextField
                    label={"Reason"}
                    name={"Reason"}
                    onChange={(e) => setDeleteReason(e.target.value)}
                    value={deleteReason}
                    fullWidth
                    multiline
                />
            </div>

            <div style={{marginTop: 10, float: "right"}}>
                <AgyleButton
                    onClick={removeSession}
                    variant="contained"
                    disabled={deleteReason.length < 3}
                >
                    Accept
                </AgyleButton>
            </div>
        </AgyleDialog>
        }

        {/*{isConfirmModalOpen &&*/}
        {/*<MessageBox*/}
        {/*    onClose={closeConfirmModal}*/}
        {/*    title={"Please Confirm " + (deleteRebook? "Cancel and Rebook": "Delete")}*/}
        {/*    haveAccept={{yes: "Accept", no: "Cancel"}}*/}
        {/*    onAccept={removeSession}*/}
        {/*    disableSave*/}
        {/*    fullWidth*/}
        {/*    bookAdmission*/}
        {/*    disabled={!deleteReason}*/}
        {/*    messageObject={renderMessage()}*/}
        {/*    open={isConfirmModalOpen}/>*/}
        {/*}*/}
        <div>
            <div  style={{  marginLeft: 250}}>
                <div className={classes.typeContainer}>
                    <div className={clsx(tab === InformationTab.FORM && classes.itemSelected, classes.statusItem)}
                         onClick={() => setTab(InformationTab.FORM)}>
                        FORM
                    </div>
                    <div className={clsx(tab === InformationTab.DECISIONS && classes.itemSelected, classes.statusItem)}
                         onClick={() => setTab(InformationTab.DECISIONS)}>
                        DECISIONS
                    </div>
                    <div className={clsx(tab === InformationTab.CONTACT_HISTORY && classes.itemSelected, classes.statusItem)}
                         onClick={() => setTab(InformationTab.CONTACT_HISTORY)}>
                        CONTACT HISTORY
                    </div>
                </div>
            </div>

            {!markedOperation  && <div style={{textAlign: "center", margin: 50, fontWeight: "bold", fontSize: 20}}>Select Admission to view</div>}

            <div style={{marginLeft: 55, marginTop: 20}}>
                {tab === InformationTab.FORM && markedOperation &&
                <div>
                    <div className={classes.header}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <div style={{marginRight: 10}}> {markedOperation?.patientName}</div>
                            <div style={{marginRight: 10}}>
                                {markedOperation && <PatientAlertsComponent patientObject = {markedOperation?.patient}/>}
                            </div>
                            {markedOperation?.procedures.map((procedure, index) => {
                                return <div className={classes.procedure}>
                                    <div className={classes.procedureSpecialty}> {procedure?.specialty} </div>
                                </div>
                            })}
                        </div>
                        <div className={classes.formButtons}>{renderButtons()}</div>
                    </div>
                    {markedOperation &&
                    <div style={{height: "calc(100vh - 220px)", overflow: "auto"}} className={"scroll-normal-white"}>
                        <BookAdmissionForm historyView = {historyView} inCalendar operation={markedOperation} transfer={transfer}/>
                    </div>
                    }
                </div>
                }
                {tab !== InformationTab.FORM && markedOperation && <AdmissionDecisions type={tab} admissionType={admissionType}/>}
            </div>

        </div>

    </div>)
}

export default AdmissionInformation;